/* CRO product page (4WDCraft) — gallery, option cards, offers, totals, add to cart */
(function () {
  function initCpp(root) {
    if (root.getAttribute('data-cpp-ready')) return;
    root.setAttribute('data-cpp-ready', '1');
    var dataEl = root.querySelector('script[data-cpp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
    var fmt = root.getAttribute('data-money') || '';
    var disc = parseInt(root.getAttribute('data-disc'), 10) || 0;
    var minQty = parseInt(root.getAttribute('data-min'), 10) || 2;
    var form = root.querySelector('form.cpp-form');
    if (!form) return;
    var idInput = form.querySelector('input[name=id]');
    var qtyInput = form.querySelector('input[name=quantity]');
    var errEl = root.querySelector('[data-err]');
    var pressedOffer = root.querySelector('[data-offers] [aria-pressed=true]');
    var qty = pressedOffer ? (parseInt(pressedOffer.getAttribute('data-qty'), 10) || 1) : 1;
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    var selected = current ? current.options.slice() : [];

    function money(cents) {
      var n = cents / 100;
      var withCommas = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (!fmt) return '$' + withCommas;
      var vals = {
        amount: withCommas,
        amount_no_decimals: String(Math.round(n)),
        amount_with_comma_separator: n.toFixed(2).replace('.', ',')
      };
      var out = fmt.replace(/{{[^}]*}}/g, function (m) {
        var k = m.slice(2, -2).trim();
        return Object.prototype.hasOwnProperty.call(vals, k) ? vals[k] : m;
      });
      return out.replace(/<[^>]*>/g, '');
    }
    // Same rounding as Shopify's automatic discount: the discount is rounded down, then subtracted.
    function finalFor(unit, q) {
      var total = unit * q;
      if (q >= minQty && disc > 0) return total - Math.floor(total * disc / 100);
      return total;
    }
    function setPressed(group, btn) {
      group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    }
    function setText(sel, txt) { root.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; }); }
    function setHidden(sel, hide) { root.querySelectorAll(sel).forEach(function (el) { el.hidden = hide; }); }

    function update(updateUrl) {
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      })[0];
      if (match) current = match;
      if (!current) return;
      idInput.value = current.id;
      qtyInput.value = qty;
      var unit = current.price;
      var cmp = current.compare_at_price && current.compare_at_price > unit ? current.compare_at_price : unit;

      setText('[data-unit]', money(unit));
      setText('[data-unit-save]', 'You save ' + money(cmp - unit));
      setHidden('[data-unit-save]', cmp <= unit);

      // Offer cards: per-item price is the big number (crossed-out = regular price of one item); the total sits in the small line.
      root.querySelectorAll('[data-offers] [data-qty]').forEach(function (b) {
        var q = parseInt(b.getAttribute('data-qty'), 10);
        var regular = cmp * q;
        var fin = finalFor(unit, q);
        var saved = regular - fin;
        var f = b.querySelector('[data-final]');
        var r = b.querySelector('[data-regular]');
        var e = b.querySelector('[data-each]');
        if (f) {
          f.textContent = money(Math.floor(fin / q));
          var per = document.createElement('small');
          per.textContent = '/each';
          f.appendChild(per);
        }
        if (r) { r.textContent = money(cmp); r.hidden = saved <= 0; }
        if (e) {
          e.textContent = '';
          var tot = document.createElement('strong');
          tot.className = 'cpp-tot';
          tot.textContent = money(fin) + ' total';
          e.appendChild(tot);
          if (saved > 0) e.appendChild(document.createTextNode(' · You save ' + money(saved)));
        }
      });

      var regularT = cmp * qty;
      var finT = finalFor(unit, qty);
      var savedT = regularT - finT;
      setText('[data-total]', money(finT));
      setText('[data-total-compare]', money(regularT));
      setText('[data-total-save]', 'You save ' + money(savedT) + ' (' + Math.round(savedT / regularT * 100) + '%)');
      setHidden('[data-total-compare], [data-total-save]', savedT <= 0);

      var available = !!current.available;
      root.querySelectorAll('[data-atc], [data-atc-proxy]').forEach(function (b) { b.disabled = !available; });
      setText('[data-atc-label]', available ? 'Add to cart' : 'Sold out');
      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    var thumbs = root.querySelector('[data-thumbs]');
    var mainImg = root.querySelector('[data-main]');
    if (thumbs && mainImg) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        setPressed(thumbs, btn);
        mainImg.removeAttribute('srcset');
        mainImg.src = btn.getAttribute('data-src');
      });
    }
    root.querySelectorAll('[data-option]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        setPressed(group, btn);
        selected[parseInt(group.getAttribute('data-option'), 10)] = btn.getAttribute('data-value');
        update(true);
      });
    });
    var offers = root.querySelector('[data-offers]');
    if (offers) {
      offers.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        setPressed(offers, btn);
        qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        update(false);
      });
    }

    function setBusy(busy) {
      root.querySelectorAll('[data-atc], [data-atc-proxy]').forEach(function (b) { b.disabled = busy || !(current && current.available); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) errEl.hidden = true;
      setBusy(true);
      fetch(root.getAttribute('data-add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }] })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function () {
        window.location.href = root.getAttribute('data-cart');
      }).catch(function (err) {
        if (errEl) {
          errEl.textContent = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
          errEl.hidden = false;
        }
        setBusy(false);
      });
    });
    root.querySelectorAll('[data-atc-proxy]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    });

    update(false);
  }

  function initAll() { document.querySelectorAll('.cpp').forEach(initCpp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();